import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';

import styles from './styles.module.css';
import CardsSection from '../Common/CardsSection';
import {
  representativeSections,
  type QubicaContentProps,
  type QubicaViewProps,
} from '../Common/utils';

/**
 * VideoView view component class.
 * @function NationView
 * @params {object} content object.
 * @returns {string} Markup of the view.
 */

export interface NationViewProps extends QubicaViewProps {
  content: QubicaContentProps & {
    district_sales_manager?: QubicaContentProps[];
    regional_sales_manager?: QubicaContentProps[];
    specific_locale?: QubicaContentProps[];
    related_locale?: QubicaContentProps[];
    headquarter?: QubicaContentProps[];
  };
}

export const qubicaBaseSections = [
  'specific_locale',
  'related_locale',
  'headquarter',
] as const;

const NationView = ({ content }: NationViewProps) => {
  const intl = useIntl();
  const Container = config.getComponent('Container').component || 'div';

  return (
    <Container>
      <div>
        {content.title && (
          <h1 className={cx('documentFirstHeading')}>{content.title}</h1>
        )}

        <div className={cx('has--fullwidth--true', styles.content)}>
          <Container className={styles.cardSection}>
            <div>
              <h2 className={cx(styles.sectionTitle, styles.macroSectionTitle)}>
                {intl.formatMessage(messages.representatives_label)}
              </h2>
              {representativeSections.map((section) => (
                <CardsSection
                  content={content}
                  section={section}
                  key={section}
                  bg="white"
                />
              ))}
            </div>
            <div className={styles.qubicaBaseSection}>
              {qubicaBaseSections.map((section) => (
                <CardsSection
                  content={content}
                  section={section}
                  key={section}
                  bg="white"
                />
              ))}
            </div>
          </Container>
        </div>
      </div>
    </Container>
  );
};

export default NationView;

const messages = defineMessages({
  representatives_label: {
    id: 'representatives_label',
    defaultMessage: 'Representatives',
  },
});
